/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermDto } from '../../models/term-dto';

export interface InfoControllerGetTermV1$Params {
  key: string;
}

export function infoControllerGetTermV1(http: HttpClient, rootUrl: string, params: InfoControllerGetTermV1$Params, context?: HttpContext): Observable<StrictHttpResponse<TermDto>> {
  const rb = new RequestBuilder(rootUrl, infoControllerGetTermV1.PATH, 'get');
  if (params) {
    rb.query('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermDto>;
    })
  );
}

infoControllerGetTermV1.PATH = '/api/v1/info/term';
